import { NgClass } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
// eslint-disable-next-line sonarjs/deprecation
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import {
    provideMobiUiGoogleMaps,
    provideMobiUiIconBundleSupport,
    provideMobiUiIllustrationCdnSupport,
} from '@mobi/rwc-ui-components-ng-jslib';
import {
    ConfigurationService,
    RwcFinishSpanDirective,
    RwcStartSpanDirective,
    provideAzureCore,
    withAutoAppReload,
    withLoggerAppender,
    withTracing,
} from '@mobi/rwc-utils-ng-jslib';
import { TealiumConfigLoader, TealiumTrackingModule } from '@mobi/tea-tagmanager-ng-jslib';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ALL_HTTP_INTERCEPTORS_AND_HANDLERS } from './service/interceptors';
import { SharedModule } from './shared/shared.module';
import { NumericValuePipe } from './shared/utils/numeric-value.pipe';
import { CoreEffects } from './state/effects/core.effects';
import { FatalErrorEffects } from './state/effects/fatal-error.effects';
import { metaReducers, reducers } from './state/reducers';
import { tealiumConfigLoaderFactory } from './utils/config-helpers';

@NgModule({
    declarations: [AppComponent],
    imports: [
        // eslint-disable-next-line sonarjs/deprecation
        BrowserAnimationsModule,
        NgClass,
        RwcStartSpanDirective,
        RwcFinishSpanDirective,
        SharedModule,
        AppRoutingModule,
        CoreModule,
        // noview is set by the lib automatically
        TealiumTrackingModule.forRoot({
            configLoader: {
                provide: TealiumConfigLoader,
                useFactory: tealiumConfigLoaderFactory,
                deps: [ConfigurationService],
            },
        }),
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
            },
        }),
        EffectsModule.forRoot([FatalErrorEffects, CoreEffects]),
        StoreRouterConnectingModule.forRoot(),

        ...devtools(),
    ],
    providers: [
        provideAzureCore(withAutoAppReload(), withLoggerAppender(), withTracing()),
        ...ALL_HTTP_INTERCEPTORS_AND_HANDLERS,
        NumericValuePipe,
        provideHttpClient(withInterceptorsFromDi()),
        provideMobiUiGoogleMaps({
            apiKey: 'AIzaSyD7e9217MG0KCv5TNG6xB3IEuZwM394ogA',
            mapId: '937f993ee43b74cf',
        }),
        provideMobiUiIconBundleSupport(),
        provideMobiUiIllustrationCdnSupport(),
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}

function devtools() {
    return environment.production
        ? []
        : [
              StoreDevtoolsModule.instrument({
                  maxAge: 25, // Retains last 25 states
                  autoPause: true, // Pauses recording actions and state changes when the extension window is not open
              }),
          ];
}
